import React, { Component } from 'react';
import PropTypes from 'prop-types';
import numeral from 'numeral';
import Chart from '../Chart';
import './styles.css';

class AdminEconomicChart extends Component {
	formatData(value) {
		return `${numeral(value).format('0.0a')}`;
	}
	render() {
		const { data, options, selectedKpi } = this.props;
		return (
			<div className="economic-chart">
				<Chart
					option={{
						grid: {
							width: '60%',
							left: '35%'
						},
						color: [
							'#50e3c2',
							'#f8e71c',
							'#7ed321',
							'#4a90e2',
							'#d0021b',
							'#bd10e0',
							'#efb43f'
						],
						textStyle: {
							color: 'rgb(72, 73, 86)'
						},

						legend: {
							type: 'scroll',
							orient: 'vertical',
							top: '15%',
							left: '5%',
							data: data.map(row => row.label),
							textStyle: {
								color: 'rgb(72, 73, 86)'
							}
						},

						xAxis: {
							type: 'category',
							data: ['YEAR 1', 'YEAR 2', 'YEAR 3'],
							offset: 8,
							boundaryGap: false
						},

						yAxis: {
							type: 'value',
							axisLabel: {
								formatter: value => this.formatData(value),
								padding: [3, 5]
							},
							splitLine: {
								show: false
							}
						},

						series: data.map(row => ({
							name: row.label,
							type: 'line',
							data: row.variables.find(variable => variable.id === selectedKpi)
								.values,
							label: {
								fontWeight: 'lighter',
								fontSize: 9,
								emphasis: {
									formatter: params => this.formatData(params.value),
									show: true,
									position: 'top'
								}
							}
						})),
						...options
					}}
				/>
			</div>
		);
	}
}

AdminEconomicChart.propTypes = {
	options: PropTypes.object,
	data: PropTypes.arrayOf(
		PropTypes.shape({
			label: PropTypes.string,
			values: PropTypes.arrayOf(PropTypes.object)
		})
	)
};

export default AdminEconomicChart;
